const videos = [
  {
    title: '某顶流深夜发文引全网热议，评论区炸了',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20visualization%20of%20social%20media%20viral%20content%20with%20glowing%20notification%20bubbles%20and%20trending%20indicators%2C%20warm%20coral%20and%20amber%20tones%2C%20modern%20digital%20media%20concept%2C%20soft%20gradients%2C%20minimal%20design%20with%20overlapping%20elements%2C%20editorial%20style&width=800&height=500&seq=media-01&orientation=landscape',
    views: '128.6万',
    tag: '娱乐圈',
    time: '2小时前',
  },
  {
    title: '综艺节目录制现场突发状况，嘉宾反应引猜测',
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20television%20studio%20set%20with%20dramatic%20lighting%20and%20abstract%20performance%20elements%2C%20warm%20stage%20lights%20in%20amber%20and%20coral%2C%20entertainment%20show%20concept%2C%20editorial%20photography%20style%2C%20soft%20atmospheric%20glow%2C%20minimal%20composition&width=800&height=500&seq=media-02&orientation=landscape',
    views: '96.3万',
    tag: '综艺',
    time: '5小时前',
  },
  {
    title: '某品牌代言人突然宣布解约，粉丝圈震动',
    cover: 'https://readdy.ai/api/search-image?query=Corporate%20brand%20announcement%20concept%20with%20abstract%20geometric%20shapes%20and%20dramatic%20contrast%20lighting%2C%20warm%20amber%20and%20deep%20coral%20color%20palette%2C%20business%20news%20visualization%2C%20modern%20editorial%20design%2C%20clean%20composition&width=800&height=500&seq=media-03&orientation=landscape',
    views: '215.8万',
    tag: '品牌代言',
    time: '8小时前',
  },
  {
    title: '机场私服穿搭遭热议，网友分成两派激烈讨论',
    cover: 'https://readdy.ai/api/search-image?query=Fashion%20and%20style%20discussion%20concept%20with%20abstract%20clothing%20silhouettes%20and%20trending%20topic%20visuals%2C%20warm%20neutral%20tones%20with%20coral%20accents%2C%20editorial%20fashion%20magazine%20style%2C%20soft%20lighting%2C%20elegant%20composition&width=800&height=500&seq=media-04&orientation=landscape',
    views: '87.2万',
    tag: '时尚八卦',
    time: '12小时前',
  },
  {
    title: '剧组路透照意外曝光新剧造型，书粉集体沸腾',
    cover: 'https://readdy.ai/api/search-image?query=Film%20production%20behind%20scenes%20abstract%20concept%20with%20camera%20and%20set%20elements%2C%20warm%20dramatic%20lighting%20in%20amber%20and%20deep%20orange%20tones%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20style%2C%20mysterious%20mood&width=800&height=500&seq=media-05&orientation=landscape',
    views: '176.4万',
    tag: '影视爆料',
    time: '1天前',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-label text-primary-600 bg-primary-50 px-3 py-1 rounded-full">视频精选</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-3">
            精彩视频
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-[560px] mx-auto">
            最受关注的吃瓜视频内容，无需注册即可浏览
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {videos.map((video, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={video.cover}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded text-[10px] font-label bg-background-950/70 text-background-100 whitespace-nowrap">
                    {video.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="text-xs text-background-100 flex items-center gap-1">
                    <i className="ri-play-circle-line"></i>
                    {video.views}
                  </span>
                  <span className="text-xs text-background-300">{video.time}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-label font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}